import ImageUploaderWithRef from './ImageUploader';

export default ImageUploaderWithRef;
